import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { OrganizationOrigin } from '@masar/common/enums';
import { isNotOrigin } from '@masar/common/utils';

@Directive({
    selector: '[appIsNotOrigin]',
    standalone: false,
})
export class IsNotOriginDirective {
    private organizationOrigins: OrganizationOrigin[];

    public constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) {}

    @Input()
    public set appIsNotOrigin(origins: OrganizationOrigin[]) {
        this.organizationOrigins = origins;
        this.updateView();
    }

    private updateView(): void {
        this.viewContainer.clear();
        if (isNotOrigin(this.organizationOrigins)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}
